import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUserDocuments = createSelector(
  [(store: RootState) => store.userShow.userDocumentsList],
  (data) => data
);
